import React from 'react'
import PropTypes from 'prop-types'
import loadable from '@loadable/component'
import { graphql } from 'react-apollo'

import loadBlog from './loadBlogs.gql'

const BlogGrid = loadable(() => import('@albatross/common-components/dist/components/Blogs/Grid'))

const BlogsGridContainer = (props) => {
  const { headingText, headingLink, data, showFeatured, venture, enableContentful } = props
  if (data.loading) {
    return null
  }
  if (!data.loading && data.error) {
    return data.error
  }

  const blogs = data.games ?? data.contentfulBlogs ?? []
  const newList = [...blogs]

  // showFeatured can be true or the number of features to show if coming from contentful
  const featuresToShow = isNaN(parseInt(showFeatured)) ? 2 : showFeatured
  const featuredList = showFeatured ? newList.splice(0, featuresToShow) : []

  return (
    <BlogGrid
      blogList={newList}
      featuredBlogList={featuredList}
      headingText={headingText}
      headingLink={headingLink}
      showFeatured={Boolean(showFeatured)}
      venture={venture}
      defaultAuthorImage="/uk/jackpotjoy/AuthorFallback.png"
      enableContentful={enableContentful}
    />
  )
}

BlogsGridContainer.propTypes = {
  data: PropTypes.object.isRequired,
  headingText: PropTypes.string,
  headingLink: PropTypes.string,
  showFeatured: PropTypes.bool,
  venture: PropTypes.string,
  enableContentful: PropTypes.bool
}

function getVariables (props) {
  const variables = {
    published: true,
    released: true,
    enableContentful: props.enableContentful
  };

  ['subCategoryId', 'categoryId', 'tags', 'sort', 'sortOrder', 'limit'].forEach((property) => {
    if (props.query && props.query[property]) {
      variables[property] = props.query[property]
    }
  })
  return variables
}

export default graphql(loadBlog, {
  options: (props) => {
    return { variables: getVariables(props) }
  }
})(BlogsGridContainer)
